import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";
const colors = ["success", "error", "info", "primary"];
function OrdersOverview(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);
  const funnelWidth = (index, total) => {
    const max = 100;
    const min = 60;
    return max - ((max - min) / (total - 1)) * index;
  };
  return (
    <Card sx={{ height: "100%", overflow: "hidden" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Top Selling Rates
        </MDTypography>
      </MDBox>
      <MDBox p={2} display="flex" justifyContent="center" alignItems="center">
        <Box
          sx={{
            width: "100%",
            maxWidth: "400px",
            position: "relative",
            clipPath: "polygon(0 0, 100% 0, 65% 100%, 35% 100%)",
            paddingBottom: "10px",
          }}
        >
          {Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => (
              <MDBox
                key={index}
                bgColor={colors[index % colors.length]}
                sx={{
                  width: `${funnelWidth(index, data.length)}%`,
                  margin: "auto",
                  height: "60px",
                  marginBottom: "4px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#FFFFFF",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                  "&:hover": {
                    filter: "brightness(1.1)",
                  },
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  px: 1,
                }}
              >
                <MDTypography
                  variant="button"
                  color="white"
                  textTransform="capitalize"
                  fontWeight="medium"
                  sx={{ px: 4 }}
                >
                  {item.displayName}
                </MDTypography>
                <MDTypography variant="caption" color="white" opacity={0.8}>
                  {item.date}
                </MDTypography>
              </MDBox>
            ))
          ) : (
            <MDBox textAlign="center" py={4} px={2}>
              <MDTypography variant="caption" sx={{ px: 2 }}>
                No data available
              </MDTypography>
            </MDBox>
          )}
        </Box>
      </MDBox>
    </Card>
  );
}
export default OrdersOverview;
